import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import TextareaInput from "../../Components/Inputs/TextareaInput";
import {useSelector} from "react-redux";
import ImageInput from "../../Components/Inputs/ImageInput";

const shopStatuses = [
  {id: 0, name: 'Disabled'},
  {id: 1, name: 'Active'}
]

export default function ({register, errors, control, data, watch}) {

  const user = useSelector(state => state.user);

  return (
    <>
        <ImageInput
            name="image"
            parentClasses="col-xl-4 col-sm-5 offset-xl-0 offset-sm-1"
            classes="d-inline-block"
            id="imageUpload"
            register={register}
            control={control}
            errorMessage={errors?.image}
        />
      <TextInput
        label="Shop Name"
        name="name"
        register={register}
        required={true}
        errorMessage={errors?.name}
      />
      <TextInput
        label="Organization Name"
        name="organization"
        register={register}
        required={true}
        errorMessage={errors?.organization}
      />
      <ReactSelectInput
        label="Choose organization type"
        name="organization_type_id"
        className="my-5"
        register={register}
        required={true}
        options={data?.organization_types}
        errorMessage={errors?.organization_type}
        control={control}
      />
      <TextInput
        label="Identification Code"
        name="identification_code"
        className=""
        register={register}
        required={true}
        type="number"
        pattern="[0-9]{9,9}"
        errorMessage={errors?.identification_code}
      />
      <TextInput
        label="Shop E-Mail"
        name="email"
        register={register}
        required={true}
        errorMessage={errors?.email}
      />
      <TextInput
        label="Shop Phone"
        name="mobile"
        register={register}
        required={true}
        type="tel"
        errorMessage={errors?.mobile}
      />
      <TextInput
        label="Shop Latitude"
        name="latitude"
        register={register}
        required={true}
        errorMessage={errors?.latitude}
      />

      <TextInput
        label="Shop Longitude"
        name="longitude"
        register={register}
        required={true}
        errorMessage={errors?.longitude}
      />
      <TextInput
        label="Bank Account"
        name="bank_account"
        register={register}
        required={false}
        errorMessage={errors?.bank_account}
      />
      <ReactSelectInput
        label="Choose Address Town"
        className="my-5"
        name="town_id"
        placeholder="Choose"
        register={register}
        required={false}
        options={data?.towns}
        errorMessage={errors?.town_id}
        control={control}
      />
      <TextInput
        label="Street Address"
        name="address"
        register={register}
        required={false}
        errorMessage={errors?.address}
      />
      <TextInput
        label="Responsible Person"
        name="responsible_person_name"
        register={register}
        required={false}
        errorMessage={errors?.responsible_person}
      />
      <TextInput
        label="Responsible Person Contact"
        name="responsible_person_info"
        register={register}
        required={false}
        errorMessage={errors?.responsible_person_contact}
      />
      <TextareaInput
        label="Additional Information"
        name="additional_info"
        register={register}
        required={false}
        event={true}
        watch={watch}
        maxChars={225}
        errorMessage={errors?.additional_info}
      />
      {user?.roles?.includes('Super Admin') &&
        <ReactSelectInput
          label="Choose Status"
          className="my-5"
          name="is_active"
          placeholder="Choose"
          register={register}
          required={true}
          options={shopStatuses}
          errorMessage={errors?.is_active}
          control={control}
          clearable={false}
        />
      }
    </>
  );
}